// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".article-item{height:100%}.h-product{height:25rem}.article-item.forced-hover .save-button-wrapper,.article-item:hover .save-button-wrapper{opacity:1;pointer-events:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
